import React, { useEffect, useRef, useState } from 'react';
import { Box, Button } from '@mui/material';
import EastIcon from '@mui/icons-material/East';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const ButtonContent = ({ 
    item, 
    index, 
    nextItem, 
    handleButtonClick, 
    handleExternalLink, 
    handleCopyClick 
}) => {
    const isNextItemButton = nextItem && nextItem.type === 'button';
    //console.log("ButtonContent item:", item, "nextItem:", nextItem, "isNextItemButton:", isNextItemButton);

    const darkenColor = (hex, amount = 0.1) => {
        if (!hex.startsWith('#')) return hex; // Ignore non-hex values
    
        let num = parseInt(hex.slice(1), 16);
        let r = Math.max((num >> 16) - 255 * amount, 0);
        let g = Math.max(((num >> 8) & 0x00FF) - 255 * amount, 0);
        let b = Math.max((num & 0x0000FF) - 255 * amount, 0);
    
        return `rgb(${r}, ${g}, ${b})`;
    };
    

    // Refs for buttons
    const buttonRefs = useRef([]);
    const [buttonWidth, setButtonWidth] = useState(null);

    useEffect(() => {
        if (isNextItemButton) {
            const widths = buttonRefs.current.map(ref => ref?.offsetWidth || 0);
            const maxWidth = Math.max(...widths);
            setButtonWidth(maxWidth);
        }
    }, [isNextItemButton]);

    const renderButton = (buttonItem, key, refIndex) => (
        <Button
            key={key}
            className="game-section-button"
            onClick={() => {
                if (buttonItem.linkType === 'external') {
                    handleExternalLink(buttonItem.url);
                } else if (buttonItem.linkType === 'copy') {
                    handleCopyClick();
                } else {
                    handleButtonClick(buttonItem.page);
                }
            }}
            ref={el => buttonRefs.current[refIndex] = el}
            sx={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid #373737',
                borderRadius: '4px',
                height: '32px',
                fontSize: '12px',
                fontWeight: '700',
                whiteSpace: 'nowrap',
                gap: '6px',
                padding: '8px 22px',
                textTransform: 'none',
                backgroundColor: buttonItem.backgroundColor || 'transparent',
                color: buttonItem.textColor || '#373737',
                borderColor: buttonItem.borderColor || '#373737',
                minWidth: buttonWidth ? `${buttonWidth}px` : 'auto',
                '&:hover': {
                    backgroundColor: buttonItem.hoverBackgroundColor ?? (buttonItem.backgroundColor ? darkenColor(buttonItem.backgroundColor, 0.1) : '#f0f0f0'),
                    color: buttonItem.hoverTextColor ?? (buttonItem.textColor ? darkenColor(buttonItem.textColor, 0.2) : '#000'),
                    borderColor: buttonItem.hoverBorderColor ?? (buttonItem.borderColor ? darkenColor(buttonItem.borderColor, 0.2) : '#000'),
                },

                ...buttonItem.sx
            }}
        >
            {buttonItem.text}
            {buttonItem.linkType === 'copy' ? 
                <ContentCopyIcon sx={{ fontSize: '16px' }} /> : 
                <EastIcon sx={{ fontSize: '16px' }} />
            }
        </Button>
    );

    if (isNextItemButton) {
        return (
            <Box 
                key={index} 
                sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    gap: '16px', 
                    marginBottom: item.marginBottom || '16px', 
                    flexWrap: 'wrap' 
                }}
            >
                {renderButton(item, `button-${index}-1`, 0)}
                {renderButton(nextItem, `button-${index}-2`, 1)}
            </Box>
        );
    } else {
        return (
            <Box 
                key={index} 
                sx={{ 
                    display: 'flex', 
                    justifyContent: 'center', 
                    marginBottom: item.marginBottom || '16px' 
                }}
            >
                {renderButton(item, `button-${index}`, 0)}
            </Box>
        );
    }
};

export default ButtonContent;
